import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { ApiService } from 'app/api.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import * as _moment from 'moment';
import {  Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApprovalTimelineData } from 'app/components/approval-timeline/approval-timeline.component';
import { ApprovalTimelineDialogComponent } from 'app/components/approval-timeline/approval-timeline-dialog.component';
import { formatDate } from '@angular/common';
import { FormControl } from '@angular/forms';
import { DocumentTracingModalComponent } from 'app/components/document-tracing-modal/document-tracing-modal.component';
const moment = _moment;
import { AdminService } from 'app/admin.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ChangeDetectorRef } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { ReOpenService } from 'app/reopen.service';
import { CancelApprovalService } from 'app/cancel-approval.service';
import { UiPanelAction, UiPanelMode, UiApprovalStep } from 'app/shared/ui/models/ui-document-panel.model';
import { UiBadgeVariant } from 'app/shared/ui/models/ui-badge.model';
import { UiUnsavedChangesDialogComponent, UnsavedChangesResult } from 'app/shared/ui/document-panel/ui-unsaved-changes-dialog/ui-unsaved-changes-dialog.component';
@Component({
  selector: 'app-create-requisition-master-dialog',
  templateUrl: './create-requisition-master-dialog.component.html',
  styleUrls: ['./create-requisition-master-dialog.component.scss'],
  host: { class: 'ui-document-panel-host' },
})
export class CreateRequisitionMasterDialogComponent {
  branchAutoTrigger!: MatAutocompleteTrigger;
  dataControl = new FormControl('');
  store_data: any;
  store: any[] = [];
  requesition_date: any;
  req_no: any;
  productList: any[] = [];
  products: any[] = [];
  form: FormGroup;
  store_id: any;
  profitCostData: any[] = [];
  filteredProfitCostData: any[] = [];
  selectedProfitCosts: any;
  today: string; 
  isHsnNo = false;
  isUom = false;
  isSpecification = false;
  isSku = false;
  productForm: FormGroup;
  combinedDropdownData: any[] = [];
  sku_id: any = null;
  isStore = false;
  documentTypes = ['Goods','Services','Fixed Asset'];
  document_type:any;
  profitCostDatas: any[] = [];
  filteredSections: any =[];
  section_data: any;
  selectedSections: any;
  price: number;
  isPrice = false;
  ledgerSummary: { category_id: string, total: number,category_name: string ,total_budget?: number,balance?: number}[] = [];
  budget_data:any;
  req_data:any;
  sku_data:any;
  selected: Moment = moment();
  filteredPoData: any[] = [];
  poData: any[] = [];
  selectedDate: any;
  item_data: any = [];
  item_id: any;
  skuResponseData: any[] = [];
  service_data: any = [];
  filteredSkus: any[] = [];
  selectedSkuName: string = '';
  selectedServiceId: number | null = null;
  branch: any;
  branchdata: any[] = [];
  servicePcCcData: any[] = [];
  goodPcCcData: any[] = [];
  selectedbranch:any;
  isInputDisabled: boolean = false;
  filteredServices: any[] = [];
  remark: any;
  category_ids: any[] = [];
  current_requisition: any[] = [];
  calculated_budget: any = {};
  isView: boolean = false;
  panelMode: UiPanelMode = 'create';
  private enteredEditFromView = false;
  private editSnapshot: string | null = null;
  user_id: number | null = null;
  status: any[] = [];
  isApprovalStatus: boolean = false;
  isAllowPr: boolean = false;
  filtered_item_data: any[]=[];
  PcCcData: any[] = [];
  unit_data: any = [];
  fa_item_data: any = [];
  filtered_fa_item_data: any[]=[];
  previousBranch: any;
  previousProfitCost: any;
  previousSections: any;
  previousDocumentType: any;
  offset = 0;
  limit = 100;
  hasMore = true;
  loading = false;
  branchSearch = '';
  branchNameMap = new Map<number, string>();
  profitCostOffset = 0;
  profitCostLimit = 100;
  profitCostHasMore = true;
  loadingProfitCost = false;
  profitCostSearch = '';
  loadingSection= false;
  allSections: any[] = [];
  sectionOffset = 0;
  sectionLimit = 100;
  sectionLoading = false;
  sectionHasMore = true;
  sectionSearch = '';
  isBudgetDirty = false;
  private profitCostScrollAttached = false;
  @ViewChild(MatSelect) branchSelect!: MatSelect;
  get Object() {
    return Object;
  }
  isUploading: boolean = false;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  constructor(
    private apiService: ApiService, 
    public dialogRef: MatDialogRef<CreateRequisitionMasterDialogComponent>, 
    private fb: FormBuilder, 
    private dialog: MatDialog,
    private adminService: AdminService,
    private cdr: ChangeDetectorRef,
    private reopenService: ReOpenService,
    private cancelApprovalService: CancelApprovalService,
    @Inject(MAT_DIALOG_DATA) public data: { id?: number; date?: string; req_no?: string; store_id?: any; products?: any[];profit_cost_id?: any;document_type?: any;  section_id?: any; approval_status?: string; type?: string;branch_id?: any; purchase_date: string;remark?:any;category_ids?:any;current_requisition?:any;}
            

  ) {
    this.form = this.fb.group({
      store_data: ['', Validators.required],
      //req_no: [{ value: '', disabled: true }],
      requesition_date: ['', Validators.required],
      selectedProfitCosts:['', Validators.required],
      document_type:['', Validators.required],
      selectedSections:['', Validators.required]
    });

    this.requesition_date = data?.date;
    this.selectedDate = data?.purchase_date;
    this.req_no = data?.req_no;
    //this.store_id = data?.store_id;
    //this.store_data = data?.store_id;
    this.branch= data?.branch_id;
    this.remark= data?.remark;
    this.selectedbranch= this.branch;
    this.category_ids= this.data.category_ids??[];
    this.current_requisition= this.data.current_requisition??[];
      console.log('category_ids', this.category_ids);
      console.log('current_requisition', this.current_requisition);
    if (this.data.section_id) {
      this.fetchSkusBySection(this.data.section_id);
    }
    // this.fetchProfitCostData();
    // this.fetchData();
  //  this.selectedProfitCosts = data?.profit_cost_id;
  //  this.fetchStoreData();
    this.selectedSections = data?.section_id;
    this.previousSections = data?.section_id;
    this.selectedProfitCosts = data?.profit_cost_id;
    this.previousProfitCost = data?.profit_cost_id;
    this.previousBranch = data?.branch_id;
    this.selectedbranch = data?.branch_id;
    this.document_type = data?.document_type;
    this.previousDocumentType = data?.document_type;
    if (this.branch) {
      this.fetchProfitCostData();
    }
    if (this.selectedProfitCosts) {
      this.fetchStoreData();
    }
    if (this.data.document_type === 'Goods' && this.selectedProfitCosts) {
      this.fetchItemData();
    } else if (this.data.document_type === 'Fixed Asset') {
      this.fetchFaItemData();
    } else if (this.data.document_type === 'Services' && this.selectedProfitCosts && this.selectedSections) {
      this.fetchServiceData(this.selectedProfitCosts, this.selectedSections);
    }

    // this.selectedSections = data?.section_id;
    if (this.data && this.data.products) {
      // this.fetchCombinedData(this.data.section_id);
      this.selectedSections= data?.section_id;
      this.productList = this.data.products.map((product: any) => ({
        sku_id: this.sku_id,
        description: product.description,
        quantity: product.quantity,
        hsn_no: product.hsn_no,
        start_date: product.start_date,
        end_date: product.end_date,
        uom: product?.uom,
        unit_id: product?.unit_id,
        sku_name: product?.sku_name,
        service_name:product?.service_name,
        id: product?.id,
        type: product.item_service_type,
        price:product?.price,
        value:product?.value,
        ledger_name:product?.ledger_name,
        ledger_id:product?.ledger_id,
        item_id:product?.item_id,
        item_name:product?.item_name,
        branch_name:product?.branch_name,
        profit_cost_name:product?.profit_cost_name,
        category_name:product?.category_name,
        category_id:product?.category_id,
      }));
    }
    if (this.data?.id && this.data?.type == "Update") {
      this.isInputDisabled = false;
       this.isView=false;
    }
     if (this.data?.type == "View") {
      this.isInputDisabled = true;
      this.isView=true;
     }
    this.initPanelMode();
    const userString = localStorage.getItem('data');
    const user = userString ? JSON.parse(userString) : {};
    this.user_id = user?.id ?? null;
  }
  fetchItemData() {
    if (!this.selectedProfitCosts) {
      this.item_data = [];
      this.filtered_item_data = [];
      return;
    }
    const postData = {
      profit_cost_id: this.selectedProfitCosts
    };
    this.apiService.getItemByProfitCost(postData).subscribe(
      (response) => {
        this.item_data = response;
        this.filtered_item_data = [...this.item_data];
        console.log('Data from API:', this.item_data);
        if (this.selectedSections) {
          this.fetchSkuData(this.selectedSections)
        }

      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  private refreshLineItemOptions(): void {
    if (!this.document_type) {
      return;
    }
    switch (this.document_type) {
      case 'Goods':
        if (this.selectedProfitCosts) {
          this.fetchItemData();
        }
        break;
      case 'Services':
        if (this.selectedProfitCosts && this.selectedSections) {
          this.fetchServiceData(this.selectedProfitCosts, this.selectedSections);
        }
        break;
      case 'Fixed Asset':
        this.fetchFaItemData();
        break;
    }
  }

  onSectionSelected(sectionId: any): void {
    if (!sectionId) {
      return;
    }
    this.selectedSections = sectionId;
    this.onSectionChange();
  }

  onStoreSelected(storeId: any): void {
    this.store_data = storeId;
    this.refreshLineItemOptions();
  }

  fetchServiceData(profit_cost_id: any, section_id: any) {
    const postData = {
      profit_cost_id: profit_cost_id,
      section_id: section_id
    };

    this.apiService.getServiceOfSection(postData).subscribe(
      (response: any) => {
        this.service_data = response;
        console.log('service_data', this.service_data);
        const selectedServiceId = this.selectedServiceId;
        if (selectedServiceId) {
          console.log('selectedServiceId', selectedServiceId);
          this.filteredServices = this.service_data.filter(
            (service: any) => Number(service.id) === Number(this.selectedServiceId)
          );
          this.fetcSacDetails(this.filteredServices, this.selectedProfitCosts, this.selectedSections);
        } else {
          this.productForm.patchValue({
            hsn_no: null,
            ledger_name: null,
            ledger_id: null,
            uom: null,
            unit_id: null,
            specification: null,
            store_data: null,
            store_id: null,
            price: null,
            sku_name: null,
            // item_name: null,
            // item_id: null,
            profit_cost_name: null,
            profit_cost_id: null,
            branch_name: null,
            branch_id: null,
            type: null
          });
        }
        console.log('Data from API:', this.service_data);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  fetchSkuData(section: any,index?: number) {
    this.apiService.skubystore(section).subscribe(
      (skuResponse) => {
        this.skuResponseData = skuResponse;

        if (this.item_id) {
          this.filteredSkus = this.skuResponseData.filter(sku => Number(sku.item_id) === Number(this.item_id));

          if (this.filteredSkus.length > 0) {
            this.selectedSkuName = this.filteredSkus[0].sku_name;
            if (index !== undefined) {
              this.fetchEditHsnDetails(this.filteredSkus, index);
              // this.productForm.patchValue({ sku_id: this.filteredSkus[0].id });

            } else {
              this.productForm.patchValue({ sku_id: this.filteredSkus[0].id });
              this.fetcHsnDetails(this.filteredSkus);
            }
          } else {
            alert('No SKU mapped to this item for the selected section.');
            this.selectedSkuName = '';
            this.productForm.patchValue({
              hsn_no: null,
              ledger_name: null,
              ledger_id: null,
              uom: null,
              unit_id: null,
              description: null,
              store_data: null,
              store_id: null,
              price: null,
              sku_name: null,
              // item_name: null,
              // item_id: null,
              profit_cost_name: null,
              profit_cost_id: null,
              branch_name: null,
              branch_id: null,
              type: null
            });

            // Also reset readonly flags
            this.isHsnNo = false;
            this.isUom = false;
            this.isSpecification = false;
            this.isStore = false;
            this.isPrice = false;
          }
        }
      },
      (error) => {
        console.error('Error fetching SKU data:', error);
      }
    );
  }
  // onSectionChange() {
  //   this.resetFields([
  //     'branch',
  //     'selectedProfitCosts',
  //     'selectedSections',
  //     'store_data'
  //   ]);
  //   this.item_id = null;
  //   // this.products = [];
  //   this.selectedSkuName = '';
  //   // this.productForm.reset();
  //   // this.productForm.patchValue({
  //   //   start_date: this.today,
  //   // });
  //   if (this.document_type === 'Goods') {
  //     this.fetchItemData();
  //   }
  //  else if(this.document_type === 'Services'){
  //   this.fetchServiceData(this.selectedProfitCosts,this.selectedSections);
  //   }
  //  else if(this.document_type == 'Fixed Asset'){
  //   this.fetchFaItemData();
  //   }
  // }

  onSectionChange() {
    const sectionId = this.selectedSections;
    if (!sectionId) {
      return;
    }
    if (this.previousSections == null) {
      this.previousSections = sectionId;
      this.refreshLineItemOptions();
      return;
    }
    if (this.previousSections === sectionId) {
      return;
    }
    const revertSection = () => {
      console.log('Section change cancelled3');
      setTimeout(() => {
        this.selectedSections = this.previousSections;
      });
    };
    const proceedChange = () => {
      const confirmClear = confirm(
        'Changing Section will clear details. Do you want to continue?'
      );

      if (!confirmClear) {
        console.log('Section change cancelled1');
        revertSection();
        return;
      }
      this.previousSections = sectionId;
      this.resetFields([
        'branch',
        'selectedProfitCosts',
        'store_data'
      ]);
      this.selectedSections = sectionId;
      this.item_id = null;
      this.selectedSkuName = '';
      this.refreshLineItemOptions();
    };
    if (this.data?.type === 'Update' && this.data.approval_status === 'Open') {
      const skuIds =
        this.products?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];
      this.apiService.checkNextDocument({
        doc_id: this.data.id,
        model: 'Requisition',
        sku_id: skuIds
      }).subscribe((res: any) => {
        if (res.status === false) {
          alert('Next document created. Cannot change Section.');
          revertSection();
        } else {
          proceedChange();
        }
      });
    } 
    else {
      console.log('Section change cancelled4');
      proceedChange();
    }
  }


  onItemChange(itemId: number, index: number) {
    const selectedItem = this.item_data.find(item => item.item_id === itemId);
    if (selectedItem) {
      this.dataControl.setValue(selectedItem.item_name);
      this.filterItems();
    }
    this.item_id = itemId;
    this.fetchSkuData(this.selectedSections,index);
  }
  onServiceChange(serviceId: number) {
    this.selectedServiceId = serviceId;
    this.fetchServiceData(this.selectedProfitCosts,this.selectedSections);
  }

  onDocumentTypeChange(type: string) {
    if (this.previousDocumentType == null) {
      this.previousDocumentType = type;
      this.refreshLineItemOptions();
      return;
    }

    const proceedChange = () => {
      if (confirm('Changing Document Type will clear selected data. Do you want to continue?')) {
        this.document_type = type;
        this.previousDocumentType = type;
        this.resetFields([]);
        this.refreshLineItemOptions();
      } else {
        setTimeout(() => {
          this.document_type = this.previousDocumentType;
        });
      }
    };

    if (this.data?.type === 'Update' && this.data.approval_status === 'Open') {
      const skuIds = this.products?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];
      this.apiService.checkNextDocument({
        doc_id: this.data.id,
        model: 'Requisition',
        sku_id: skuIds
      }).subscribe((res: any) => {
        if (res.status === false) {
          alert('Next document created. Cannot change Document Type.');
          setTimeout(() => { this.document_type = this.previousDocumentType; });
        } else {
          proceedChange();
        }
      });
    } 
    else if(this.previousDocumentType !== type){
      proceedChange();
    }
    // this.document_type = type;
    // this.resetFields([]);
    // this.fetchReqNo(type);
    // this.branch= null;
    // this.selectedProfitCosts = null;
    // this.selectedSections=null;
    // this.store_data = null;
    // if (type === 'Services') {
    // this.fetchServiceData();
    // }
    // this.filtered_item_data = [];
    // this.filtered_fa_item_data = [];
    // this.fa_item_data = [];
    // this.item_data = [];
    // this.item_id = null;
    // this.selectedSkuName = '';
    // this.selectedServiceId = null;
    // this.products = [];
    // this.productForm.reset();
    // this.productForm.patchValue({
    //   start_date: this.today,
    // });
  }

  chosenYearHandler(normalizedYear: Date) {
    const ctrlValue = this.selectedDate || new Date();
    ctrlValue.setFullYear(normalizedYear.getFullYear());
    this.selectedDate = new Date(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    const ctrlValue = this.selectedDate || new Date();
    ctrlValue.setMonth(normalizedMonth.getMonth());
    this.selectedDate = new Date(ctrlValue);
    datepicker.close();
  }
  // fetchData(): void {
  //   this.apiService.getProfitCostCenter().subscribe(
  //     (response) => {
  //       this.profitCostDatas = response.data;
  //        console.log('service profit cost data', this.profitCostDatas);
  //       // if (this.selectedProfitCosts) {
  //       //   const found = this.profitCostDatas.find((item: any) => item.id === this.selectedProfitCosts);
  //       //   console.log('good pc/cc',found );
  //       //   if (found) {
  //       //     this.selectedProfitCosts = found.id;
  //       //      console.log('good selectedProfitCosts', this.selectedProfitCosts );
  //       //   }
  //       // }
  //       this.servicePcCcData = response.data;
  //     },
  //     (error) => {
  //       console.error("Error fetching data:", error);
  //     }
  //   );
  // }
  ngOnInit() {
    console.log('data:', this.data);
    // Initialize today with current date
    const todayDate = new Date();
    this.today = todayDate.toISOString().split('T')[0];
    
    if (!this.requesition_date && this.data?.date) {
      this.requesition_date = this.data.date;
    } else if (!this.requesition_date) {
      this.requesition_date = this.today;
    }
    
    this.fetchSection();
    this.initForm();
    if (this.data && this.data.products) {
      this.products = this.data.products.map((product, id) => ({
        ...product,
        index: id,
      }));
    }
    this.fetchBranchData();
    this.fetchunitData();
    if (this.panelMode === 'edit') {
      this.editSnapshot = this.captureEditSnapshot();
    }
  }

  private initPanelMode(): void {
    if (this.data?.type === 'View') {
      this.panelMode = 'view';
      this.isView = true;
      this.isInputDisabled = true;
    } else if (this.data?.type === 'Update') {
      this.panelMode = 'edit';
      this.isView = false;
      this.isInputDisabled = false;
    } else {
      this.panelMode = 'create';
      this.isView = false;
      this.isInputDisabled = false;
    }
  }

  get panelTitle(): string {
    switch (this.panelMode) {
      case 'create': return 'Create Requisition';
      case 'edit': return 'Edit Requisition';
      case 'view': return 'View Requisition';
      default: return 'Requisition';
    }
  }

  get statusLabel(): string {
    if (!this.data?.id) {
      return 'Draft';
    }
    return this.data.approval_status || 'Open';
  }

  get statusVariant(): UiBadgeVariant {
    const status = this.data?.approval_status;
    if (!this.data?.id || status == null || status === 'Open') {
      return 'default';
    }
    if (status === 'Approved') return 'approved';
    if (status === 'Pending') return 'pending';
    if (status === 'Rejected') return 'rejected';
    return 'default';
  }

  get approvalSteps(): UiApprovalStep[] {
    const status = this.data?.approval_status;
    const steps: UiApprovalStep[] = [
      { id: 'draft', label: 'Draft', icon: 'edit_note', state: 'upcoming' },
      { id: 'pending', label: 'Pending Approval', icon: 'schedule', state: 'upcoming' },
      { id: 'approved', label: 'Approved', icon: 'check_circle', state: 'upcoming' },
    ];

    if (!this.data?.id) {
      steps[0].state = 'active';
      return steps;
    }

    if (status == null || status === 'Open') {
      steps[0].state = 'active';
    } else if (status === 'Pending') {
      steps[0].state = 'completed';
      steps[1].state = 'active';
    } else if (status === 'Approved') {
      steps[0].state = 'completed';
      steps[1].state = 'completed';
      steps[2].state = 'completed';
    } else if (status === 'Rejected') {
      steps[0].state = 'completed';
      steps[1].state = 'rejected';
    }

    return steps;
  }

  canEdit(): boolean {
    const status = this.data?.approval_status;
    return status == null || status === 'Open' || status === 'Rejected' || status === 'Cancelled';
  }

  enterEditMode(): void {
    if (!this.canEdit()) {
      return;
    }
    if (!confirm('Do you want to edit this record?')) {
      return;
    }

    if (this.data?.approval_status === 'Cancelled') {
      if (confirm('Do you want to change status to open?')) {
        this.data.approval_status = 'Open';
      } else {
        return;
      }
    }

    this.enteredEditFromView = true;
    this.panelMode = 'edit';
    this.isView = false;
    this.isInputDisabled = false;
    if (this.data) {
      this.data.type = 'Update';
    }
    this.editSnapshot = this.captureEditSnapshot();
  }

  enterViewMode(): void {
    this.panelMode = 'view';
    this.isView = true;
    this.isInputDisabled = true;
    this.enteredEditFromView = false;
    this.editSnapshot = null;
    if (this.data) {
      this.data.type = 'View';
    }
  }

  private captureEditSnapshot(): string {
    return JSON.stringify({
      remark: this.remark ?? null,
      requesition_date: this.requesition_date ?? null,
      selectedDate: this.selectedDate ? new Date(this.selectedDate).toISOString() : null,
      branch: this.branch ?? null,
      selectedProfitCosts: this.selectedProfitCosts ?? null,
      store_data: this.store_data ?? null,
      selectedSections: this.selectedSections ?? null,
      document_type: this.document_type ?? null,
      products: this.products ?? [],
    });
  }

  hasUnsavedChanges(): boolean {
    if (this.panelMode !== 'edit' || !this.editSnapshot) {
      return false;
    }
    return this.captureEditSnapshot() !== this.editSnapshot;
  }

  private restoreFromSnapshot(): void {
    if (!this.editSnapshot) {
      return;
    }
    const snapshot = JSON.parse(this.editSnapshot);
    this.remark = snapshot.remark;
    this.requesition_date = snapshot.requesition_date;
    this.selectedDate = snapshot.selectedDate ? new Date(snapshot.selectedDate) : this.selectedDate;
    this.branch = snapshot.branch;
    this.selectedProfitCosts = snapshot.selectedProfitCosts;
    this.store_data = snapshot.store_data;
    this.selectedSections = snapshot.selectedSections;
    this.document_type = snapshot.document_type;
    this.products = (snapshot.products || []).map((product: any, index: number) => ({
      ...product,
      index,
      isEditing: false,
    }));
  }

  onClose(): void {
    this.handleExitIntent('close');
  }

  onCancel(): void {
    if (this.panelMode === 'edit' && this.enteredEditFromView) {
      this.handleExitIntent('view');
      return;
    }
    this.handleExitIntent('close');
  }

  private handleExitIntent(intent: 'close' | 'view'): void {
    if (this.panelMode === 'edit' && this.hasUnsavedChanges()) {
      this.promptUnsavedChanges(intent);
      return;
    }
    this.executeExitIntent(intent);
  }

  private executeExitIntent(intent: 'close' | 'view'): void {
    if (intent === 'view') {
      this.enterViewMode();
    } else {
      this.dialogRef.close();
    }
  }

  private promptUnsavedChanges(intent: 'close' | 'view'): void {
    const promptRef = this.dialog.open(UiUnsavedChangesDialogComponent, {
      width: '440px',
      disableClose: true,
      panelClass: 'ui-unsaved-changes-dialog',
    });

    promptRef.afterClosed().subscribe((result: UnsavedChangesResult | undefined) => {
      if (!result || result === 'cancel') {
        return;
      }
      if (result === 'discard') {
        this.restoreFromSnapshot();
        this.executeExitIntent(intent);
        return;
      }
      if (result === 'save') {
        this.Requisition(intent);
      }
    });
  }

  get footerPrimaryActions(): UiPanelAction[] {
    if (this.panelMode === 'view') {
      return this.canEdit()
        ? [{ id: 'edit', label: 'Edit', icon: 'edit', variant: 'primary', visible: true }]
        : [];
    }
    return [
      {
        id: 'save',
        label: 'Save',
        icon: 'save',
        variant: 'success',
        disabled: this.isApprovalStatus,
        visible: true,
      },
      {
        id: 'send-approval',
        label: 'Send for Approval',
        icon: 'send',
        disabled: this.isBudgetDirty,
        variant: 'primary',
        visible: !!this.data?.id && this.canEdit(),
      },
    ];
  }

  get footerSecondaryActions(): UiPanelAction[] {
    const actions: UiPanelAction[] = [
      {
        id: 'calculate',
        label: 'Calculate',
        icon: 'calculate',
        variant: 'warning',
        visible: this.panelMode !== 'view',
      },
      {
        id: 'tracing',
        label: 'Document Tracing',
        icon: 'account_tree',
        variant: 'outline',
        visible: !!this.data?.id && this.panelMode !== 'view',
      },
      {
        id: 'timeline',
        label: 'Approval Timeline',
        icon: 'timeline',
        variant: 'outline',
        visible: !!this.data?.id &&
          (this.data.approval_status === 'Pending' ||
            this.data.approval_status === 'Rejected' ||
            this.data.approval_status === 'Approved') &&
          this.panelMode !== 'view',
      },
      {
        id: 'cancel',
        label: this.panelMode === 'view' ? 'Close' : 'Cancel',
        icon: 'close',
        variant: 'ghost',
        visible: true,
      },
    ];
    return actions;
  }

  get footerDestructiveAction(): UiPanelAction | null {
    const status = this.data?.approval_status;
    if (this.panelMode !== 'view' || this.user_id !== 1 || !this.data?.id || status === 'Approved' || status === 'Pending') {
      return null;
    }
    return { id: 'delete', label: 'Delete', icon: 'delete', variant: 'danger', visible: true };
  }

  get footerOverflowActions(): UiPanelAction[] {
    if (this.panelMode !== 'view' || !this.data?.id) {
      return [];
    }
    const status = this.data.approval_status;
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', visible: true },
      {
        id: 'timeline',
        label: 'Approval Timeline',
        icon: 'timeline',
        visible: status === 'Pending' || status === 'Rejected' || status === 'Approved',
      },
      { id: 'reopen', label: 'Reopen', icon: 'replay', visible: status === 'Approved' && this.user_id === 1 },
      {
        id: 'cancel-approval',
        label: 'Cancel Approval',
        icon: 'cancel',
        visible: status === 'Pending' && this.user_id === 1,
      },
    ];
  }

  onFooterAction(actionId: string): void {
    switch (actionId) {
      case 'save':
        this.Requisition();
        break;
      case 'calculate':
        this.calculateBudget();
        break;
      case 'send-approval':
        this.sendForApprove();
        break;
      case 'tracing':
        if (this.data?.id) {
          this.viewRelatedDocuments(this.data.id);
        }
        break;
      case 'timeline':
        this.showApprovalTimeline();
        break;
      case 'edit':
        this.enterEditMode();
        break;
      case 'delete':
        this.deleteRequisition();
        break;
      case 'reopen':
        this.onReopen();
        break;
      case 'cancel-approval':
        this.onCancelApproval();
        break;
      case 'cancel':
        this.onCancel();
        break;
    }
  }

  deleteRequisition(): void {
    if (!this.data?.id) {
      return;
    }
    
    const skuIds = this.products?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];
    
    this.apiService.checkNextDocument({
      doc_id: this.data.id,
      model: 'Requisition',
      sku_id: skuIds,
      type: 'delete'
    }).subscribe((res: any) => {
      if (res.status === false) {
        alert(res.message);
      } else {
        if (confirm('Are you sure you want to delete this requisition?')) {
          this.apiService.deleteRequisition(this.data.id).subscribe(
            (response) => {
              alert(response.message);
              this.dialogRef.close({ id: this.data.id, action: 'delete' });
            },
            (error) => {
              console.error('Error deleting requisition:', error.error?.message);
              alert(error.error?.message);
            }
          );
        }
      }
    });
  }

  onReopen(): void {
    if (!this.data?.id) {
      return;
    }
    if (!confirm('Do you want to reopen this document?')) {
      return;
    }
    this.reopenService.reopen(this.data.id, 'Requisition', () => {
      this.data.approval_status = 'Open';
      this.enterViewMode();
    });
  }

  onCancelApproval(): void {
    if (!this.data?.id) {
      return;
    }
    this.cancelApprovalService.cancelApproval(this.data.id, 'Requisition', () => {
      this.data.approval_status = 'Open';
      this.enterViewMode();
    });
  }
  initForm() {
    this.productForm = this.fb.group({
      item_id: [''],
      selectedServiceId: [''],
      specification: [''],
      description: [''],
      uom: [''],
      unit_id: [''],
      hsn_no: [''],
      quantity: ['', Validators.required],
      price: [''],
      discount: [''],
      start_date: [this.today || new Date().toISOString().split('T')[0]],
      end_date: [''],
      ledger_name: [''],
      ledger_id: [''],
      sku_name: [''],
      sku_id: [''],
      item_name: [''],
      profit_cost_id: [''],
      profit_cost_name: [''],
      branch_id: [''],
      branch_name: [''],
      type: [''],
      service_name: [''],
      service_id: [''],
      category_name: [''],
      category_id: [''],
      name: [''],
    });
  }
  validateProduct(data: any, isFromImport: boolean = false): boolean {
    const startDate = new Date(data.start_date || this.today);
    const endDate = data.end_date ? new Date(data.end_date) : null;

    if (startDate.getFullYear() < 2000) {
      alert('Please enter a valid Start Date with a proper year.');
      return false;
    }
    if (endDate && endDate.getFullYear() < 2000) {
      alert('Please enter a valid Delivery Date with a proper year.');
      return false;
    }
    if (
      (this.document_type === 'Services' || this.document_type === 'Goods') &&
      !data.category_id
    ) {
      alert('Category not found');
      return false;
  // addProduct() {
  //   if (this.productForm.valid) {
  //     const startDate = new Date(this.productForm.value.start_date);
  //     const endDate = new Date(this.productForm.value.end_date);
  //     console.log("category_id",this.productForm.value.category_id);
  //     if ((this.document_type === 'Services' || this.document_type === 'Goods')
  //       && !this.productForm.value.category_id) {
  //       alert('category not found');
  //       return;
  //     }
  //     if (endDate < startDate) {
  //       alert('Delivery date cannot be before start date');
  //       return;
  //     }
  //     let quantityValue = this.productForm.value.quantity;
  //     if (this.document_type === 'Fixed Asset') {
  //       quantityValue = 1;
  //     }
  //     const newProduct = {
  //       sku_id: this.productForm.value.sku_id || this.productForm.value.service_id,
  //       service_id: this.productForm.value.service_id,
  //       hsn_no: this.productForm.value.hsn_no || '',
  //       specification: this.productForm.value.specification || '',
  //       description: this.productForm.value.description || '',
  //       uom: this.productForm.value.uom.unit_name || '',
  //       unit_id: this.productForm.value.uom.id || '',
  //       quantity: quantityValue,
  //       price: this.productForm.value.price || 0,
  //       discount: this.productForm.value.discount || 0,
  //       start_date: this.productForm.value.start_date,
  //       end_date: this.productForm.value.end_date,
  //       ledger_name: this.productForm.value.ledger_name,
  //       ledger_id: this.productForm.value.ledger_id,
  //       sku_name: this.productForm.value.sku_name,
  //       item_id: this.productForm.value.item_id,
  //       item_name: this.productForm.value.item_name,
  //       profit_cost_id: this.productForm.value.profit_cost_id,
  //       profit_cost_name: this.productForm.value.profit_cost_name,
  //       branch_id: this.productForm.value.branch_id,
  //       branch_name: this.productForm.value.branch_name,
  //       type:this.productForm.value.type,
  //       service_name: this.productForm.value.service_name,
  //       category_name: this.productForm.value.category_name,
  //       category_id: this.productForm.value.category_id,
  //       section_id: this.selectedSections,
  //       name: this.productForm.value.name,
  //     };

  //     let reorderLevel = null;
  //     if (this.filteredSkus && this.filteredSkus.length > 0) {
  //       const sku = this.filteredSkus[0];
  //       const sectionMap = sku.sku_detail_maps.find(
  //         (map: any) => Number(map.section_id) === Number(this.selectedSections)
  //       );
  //       if (sectionMap) {
  //         reorderLevel = Number(sectionMap.reorder_level);
  //       }
  //     }

  //     const existingQty = this.products
  //       .filter(p => p.section_id === this.selectedSections && p.sku_id === newProduct.sku_id)
  //       .reduce((sum, p) => sum + Number(p.quantity), 0);

  //     const newQty = Number(newProduct.quantity);
  //     const totalQty = existingQty + newQty;

  //     if (reorderLevel !== null && reorderLevel > 0 && totalQty > reorderLevel) {
  //       alert(
  //         `Total Quantity (${totalQty}) exceeds reorder level (${reorderLevel}) for section ${this.selectedSections}.`
  //       );
  //       this.productForm.patchValue({ quantity: null });
  //       return; 
  //     }
  //       // Check if category_id already exists in category_ids
  //       if (!this.category_ids.includes(this.productForm.value.category_id)) {
  //         this.category_ids.push(this.productForm.value.category_id);
  //       }

  //       // Check if category already exists in current_requisition
  //       const existingRequisitionIndex = this.current_requisition.findIndex(
  //         req => req.category_id === this.productForm.value.category_id
  //       );

  //       if (existingRequisitionIndex > -1) {
  //         // Category exists, add to existing amount
  //         this.current_requisition[existingRequisitionIndex].amount +=
  //           this.productForm.value.quantity * this.productForm.value.price;
  //       } else {
  //         console.log('category_id',this.productForm.value.category_id);
  //         console.log('category_name',this.productForm.value.category_name);
  //         console.log('amount',this.productForm.value.quantity * this.productForm.value.price);
  //         console.log('price',this.productForm.value.price);
  //         console.log('quantity',this.productForm.value.quantity);
  //         // Category doesn't exist, add new entry
  //         this.current_requisition.push({
  //           category_id: this.productForm.value.category_id,
  //           category_name: this.productForm.value.category_name,
  //           amount: quantityValue * this.productForm.value.price,
  //         });
  //     }
  //     this.products.push(newProduct);
  //     this.productForm.reset();
  //     this.productForm.patchValue({ start_date: this.today });
  //   } else {
  //     console.log('Form is not valid');
    }
    if (endDate && endDate < startDate) {
      alert('Delivery date cannot be before start date');
      return false;
    }
    let quantityValue =
      this.document_type === 'Fixed Asset'
        ? 1
        : Number(data.quantity || data.qty || 0);

    const qtyStr = quantityValue.toString();
    const qtyRegex = /^\d{1,12}(\.\d{1,3})?$/;
    if (!qtyRegex.test(qtyStr) || quantityValue <= 0) {
      alert('Please enter a valid Quantity');
      return false;
    }

    let priceValue = Number(data.price || 0);
    const priceStr = priceValue.toString();
    const priceRegex = /^\d{1,8}(\.\d{1,2})?$/;
    if (!priceRegex.test(priceStr) || priceValue < 0) {
      alert('Please enter a valid Price');
      return false;
    }
    let reorderLevel = null;
    if (this.filteredSkus && this.filteredSkus.length > 0) {
      const sku = this.filteredSkus[0];
      if (sku && sku.sku_detail_maps) {
        const sectionMap = sku.sku_detail_maps.find(
          (map: any) => Number(map.section_id) === Number(this.selectedSections)
        );
        if (sectionMap) {
          reorderLevel = Number(sectionMap.reorder_level);
        }
      }
    }

    const skuId = data.sku_id || data.service_id;

    const existingQty = this.products
      .filter(
        p =>
          p.section_id === this.selectedSections &&
          p.sku_id === skuId
      )
      .reduce((sum, p) => sum + Number(p.quantity), 0);

    const totalQty = existingQty + quantityValue;

    if (reorderLevel !== null && reorderLevel > 0 && totalQty > reorderLevel) {
      alert(
        `Total Quantity (${totalQty}) exceeds reorder level (${reorderLevel}) for section ${this.selectedSections}.`
      );
      return false;
    }
    return true;
  }

  // addProduct() {
  //   if (this.productForm.valid) {
  //     const startDate = new Date(this.productForm.value.start_date);
  //     const endDate = new Date(this.productForm.value.end_date);
  //     console.log("category_id",this.productForm.value.category_id);
  //     if ((this.document_type === 'Services' || this.document_type === 'Goods')
  //       && !this.productForm.value.category_id) {
  //       alert('category not found');
  //       return;
  //     }
  //     if (endDate < startDate) {
  //       alert('Delivery date cannot be before start date');
  //       return;
  //     }
  //     let quantityValue = this.productForm.value.quantity;
  //     if (this.document_type === 'Fixed Asset') {
  //       quantityValue = 1;
  //     }
  //     const newProduct = this.prepareProductObject(this.productForm.value);
  //     console.log("newProduct",newProduct);
  //     let reorderLevel = null;
  //     if (this.filteredSkus && this.filteredSkus.length > 0) {
  //       const sku = this.filteredSkus[0];
  //       const sectionMap = sku.sku_detail_maps.find(
  //         (map: any) => Number(map.section_id) === Number(this.selectedSections)
  //       );
  //       if (sectionMap) {
  //         reorderLevel = Number(sectionMap.reorder_level);
  //       }
  //     }

  //     const existingQty = this.products
  //       .filter(p => p.section_id === this.selectedSections && p.sku_id === newProduct.sku_id)
  //       .reduce((sum, p) => sum + Number(p.quantity), 0);

  //     const newQty = Number(newProduct.quantity);
  //     const totalQty = existingQty + newQty;

  //     if (reorderLevel !== null && reorderLevel > 0 && totalQty > reorderLevel) {
  //       alert(
  //         `Total Quantity (${totalQty}) exceeds reorder level (${reorderLevel}) for section ${this.selectedSections}.`
  //       );
  //       this.productForm.patchValue({ quantity: null });
  //       return; 
  //     }
  //       this.commonProductAddLogic(newProduct);
  //       this.productForm.reset();
  //       this.productForm.patchValue({ start_date: this.today });
  //   } else {
  //     console.log('Form is not valid');
  //   }
  // }
  addProduct() {
    if (!this.productForm.valid) {
      alert('Please fill all required fields, including Quantity.');
      console.log('Form is not valid');
      return;
    }
    const formValue = this.productForm.value;
    if (!this.validateProduct(formValue)) {
      this.productForm.patchValue({ quantity: null });
      return;
    }
    const newProduct = this.prepareProductObject(formValue);
    this.commonProductAddLogic(newProduct);
    this.productForm.reset();
    this.productForm.patchValue({ start_date: this.today });
  }
  removeProduct(index: number) {
    if (!this.data?.id) {
      this.executeRemoveProduct(index);
      return;
    }

    const product = this.products[index];
    const skuId = product?.service_id || product?.sku_id?.id || product?.sku_id;

    if (!skuId) {
      this.executeRemoveProduct(index);
      return;
    }

    this.apiService.checkNextDocument({
      doc_id: this.data.id,
      model: 'Requisition',
      sku_id: [skuId],
      type: 'delete'
    }).subscribe((res: any) => {
      if (res.status === false) {
        alert(res.message);
      } else {
        this.executeRemoveProduct(index);
      }
    });
  }

  private executeRemoveProduct(index: number) {
    if (confirm("Do you want to delete this line item?")) {
      // Get the product being removed to access its category_id
      const removedProduct = this.products[index];
      this.products.splice(index, 1);

      if (removedProduct && removedProduct.category_id) {
        const categoryIndex = this.category_ids.indexOf(removedProduct.category_id);
        if (categoryIndex > -1) {
          this.category_ids.splice(categoryIndex, 1);
        }
      }

      // Remove the corresponding entry from current_requisition array
      if (removedProduct && removedProduct.category_id) {
        const requisitionIndex = this.current_requisition.findIndex(
          req => req.category_id === removedProduct.category_id
        );
        if (requisitionIndex > -1) {
          this.current_requisition.splice(requisitionIndex, 1);
        }
      }
      this.calculateBudget();
    }
  }
  getProductTypeName(product: any): string {
    const productType = product?.type || product?.sku_id?.type || this.data.products[0]?.type;
    const productId = product?.id || product?.sku_id?.id || this.data.products[0]?.id;
    if (!productType || !productId) return '';

    const categoryGroup = this.combinedDropdownData.find((group: any) => group.category === productType);
    if (!categoryGroup) return '';

    if (productType === 'SKU') {
      const matchedItem = categoryGroup.items.find((item: any) => item.id === productId);
      return matchedItem?.sku_name || '';
    }

    if (productType === 'Service') {
      const matchedService = categoryGroup.items.find((item: any) => item.id === productId);
      return matchedService?.service_name || '';
    }

    return '';
  }
  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.key;
    if ((charCode >= '0' && charCode <= '9') || charCode === '.') {
      return true;
    }
    event.preventDefault();
    return false;
  }
  editProduct(index: number): void {
    const product = this.products[index];
    const productId = product?.sku_id || product?.id;
    const productType = product?.type || 'SKU';
    const categoryGroup = this.combinedDropdownData.find(group => group.category === productType);
    if (categoryGroup) {
      const matchedItem = categoryGroup.items.find((item: any) => item.id === productId);
      if (matchedItem) {
        product.sku_id = matchedItem;
      }
    }
    if (this.document_type === 'Services') {
      product.selectedServiceId = product.sku_id;
    }
    product.isEditing = true;
    console.log(this.products[index]);
    console.log(this.service_data);
  }
  saveProduct(index: number): void {
    const product = this.products[index];
    const startDate = new Date(product.start_date);
    const endDate = new Date(product.end_date);

    if (endDate < startDate) {
      alert('Delivery date cannot be before start date.');
      return;
    }

    const qty = Number(product.quantity || product.qty || 0);
    const price = Number(product.price || 0);

    const qtyStr = qty.toString();
    const qtyRegex = /^\d{1,12}(\.\d{1,3})?$/;
    if (!qtyRegex.test(qtyStr) || qty <= 0) {
      alert('Please enter a valid Quantity');
      return;
    }

    const priceStr = price.toString();
    const priceRegex = /^\d{1,8}(\.\d{1,2})?$/;
    if (!priceRegex.test(priceStr) || price < 0) {
      alert('Please enter a valid Price');
      return;
    }

    if (product.sku_id && typeof product.sku_id === 'object') {
      product.id = product.sku_id.id;
      product.type = product.sku_id.type;
    }
    product.isEditing = false;
    this.products = [...this.products];
    this.isBudgetDirty = true;
   

    // // Added to update totals dynamically behind the scenes
    // this.rebuildCurrentRequisition();

    // // Friendly reminder for the user
    // alert('Calculated amount has changed. Please click the calculate button to verify the budget once before saving.');
  }
  // fetchReqNo(type:any) {
  //   this.apiService.getReqNo(type).subscribe(
  //     (response) => {
  //       this.req_no = response.req_no;
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }

  fetchStoreData() {
    if (!this.selectedProfitCosts) {
      this.store = [];
      return;
    }
    const postData = {
      profit_cost_id: this.selectedProfitCosts,
    };
    console.log('profit cost id',postData);
    this.apiService.getStoreByPcCc(postData).subscribe(
      (response) => {
        this.store = response;
        console.log('store data',this.store);
        // if (this.store_id) {
        //   this.store_data = this.store.find(store => store.id === this.store_id)?.id || null;
        // }
        if (this.data?.store_id) {
          this.store_data = this.data?.store_id;
          console.log('store data html', this.store_data );
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  // onStoreSelect() {
  //   //this.fetchProfitCostData();
  // }

  fetchSection() {
  if (this.sectionLoading || !this.sectionHasMore) {
    return;
  }
  this.sectionLoading = true;
  const payload: any = {
    type: "lazyloading",
    offset: this.sectionOffset,
    limit: this.sectionLimit,
  };
  if (this.selectedProfitCosts) {
    payload.pc_cc_id = this.selectedProfitCosts;
  }
  if (this.sectionSearch) {
    payload.search = this.sectionSearch;
  }

  this.apiService.getSection(payload).subscribe(
    (response) => {
       const data = response?.section_data ?? response ?? [];
       if (this.sectionOffset === 0) {
        this.filteredSections = data;
      } else {
        this.filteredSections = [...this.filteredSections,...data];
      }
      this.section_data = this.filteredSections;
      this.sectionOffset += data.length;
       if (data.length < this.sectionLimit) {
        this.sectionHasMore = false;
      }
      if (this.data?.section_id) {
        const found = this.filteredSections.find((item: any) => item.id === this.data.section_id);
        if (found) {
          this.selectedSections = found.id;
        }
      }
      this.sectionLoading = false;
      this.cdr.detectChanges();
    },
    (error) => {
      console.error('Error fetching section data:', error);
      this.sectionLoading = false;
    }
  );
}

  fetchProfitCostData() {
  if (this.loadingProfitCost || !this.profitCostHasMore){
     return;
  }
  if (!this.branch) {
    return;
  }
  this.loadingProfitCost = true;
    const postData = {
      branch_id: this.branch,
      type:"lazyloading",
      profitcostid:this.selectedProfitCosts,
      offset: this.profitCostOffset,
      limit: this.profitCostLimit,
      search: this.profitCostSearch || undefined
    };
    this.apiService.getProfitCostByStore(postData).subscribe(
      (response) => {
        this.profitCostData = response;
        // if (this.selectedProfitCosts) {
        //   this.selectedProfitCosts = this.profitCostData.find(store => store.id === this.selectedProfitCosts)?.id || null;
        // console.log('Service selectedProfitCosts', this.selectedProfitCosts );
        // }
        // this.goodPcCcData = response;
        //  this.servicePcCcData = response;
        const data = response?.data ?? response ?? [];
        console.log("profit_cost_data",data);
         if (this.profitCostOffset === 0) {
           this.PcCcData = data;
         } else {
           this.PcCcData = [...this.PcCcData, ...data];
         }
         this.profitCostOffset += data.length;
         if (data.length < this.profitCostLimit) {
           this.profitCostHasMore = false;
         }
         this.loadingProfitCost = false;
      },
      (error) => {
        console.error('Error fetching profit cost data:', error);
        this.profitCostData = [];
        this.loadingProfitCost = false;
      }
    );
  }
  // onProfitCostChange(profitCostId: number) {
  //   this.filteredSections = this.section_data.filter(
  //     sec => sec.profit_cost_id === profitCostId
  //   );
  //   if (this.data?.type == "Update") {
  //     const proceed = confirm('Are you sure? This will reset your selected fields.');
  //     if (!proceed) {
  //       return;
  //     }
  //   }
  //    this.resetFields([
  //     'branch',
  //     'selectedProfitCosts'
  //   ]);
  //   if (this.document_type === 'Goods') {
  //     //this.fetchItemData();
  //     this.fetchStoreData();
  //   }
  //   this.fetchApprovalStatus(profitCostId);
  // }
  onProfitCostChange(profitCostId: number) {
    if (!profitCostId) return;
    if (this.previousProfitCost === undefined || this.previousProfitCost === null) {
      this.previousProfitCost = profitCostId;
      this.performProfitCostChangeLogic(profitCostId);
      return;
    }
    if (!this.isInputDisabled && this.previousProfitCost !== profitCostId) {
      const proceedChange = () => {
         if (confirm('Changing Profit/Cost Center will clear selected data. Do you want to continue?')) {
            this.resetFields(['branch', 'selectedProfitCosts']); 
            this.selectedProfitCosts = profitCostId;
            this.previousProfitCost = profitCostId; 
            this.performProfitCostChangeLogic(profitCostId);
         } else {
            setTimeout(() => { 
              this.selectedProfitCosts = this.previousProfitCost; 
            });
         }
      };
      if (this.products && this.products.length > 0) {
        if (this.data?.approval_status === 'Open') {
          const skuIds = this.products?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];
          this.apiService.checkNextDocument({
              doc_id: this.data.id,
              model: 'Requisition',
              sku_id: skuIds
          }).subscribe((res: any) => {
              if (res.status === false) {
                  alert('Next document created. Cannot change Profit Cost.');
                  setTimeout(() => { this.selectedProfitCosts = this.previousProfitCost; });
              } else {
                  proceedChange();
              }
          });
        } else {
          proceedChange();
        }
      } else {
        this.previousProfitCost = profitCostId;
        this.performProfitCostChangeLogic(profitCostId);
      }
    } else {
      this.previousProfitCost = profitCostId;
      this.performProfitCostChangeLogic(profitCostId);
    }
  }
  private performProfitCostChangeLogic(profitCostId: number) {
     this.selectedSections = null;
     this.previousSections = null;
     this.sectionOffset = 0;
     this.sectionHasMore = true;
     this.sectionLoading = false;
     this.filteredSections = [];
     this.section_data = [];

     this.fetchSection();
    if (this.document_type === 'Goods') {
      this.fetchStoreData();
    }
    this.fetchApprovalStatus(profitCostId);
    this.refreshLineItemOptions();
  }

fetchApprovalStatus(profitCostId: number) {
  this.apiService.ApproveStatus(profitCostId, 'Requisition').subscribe(
    (response: any) => {
      if (!response.status) {
        alert(response.message);
        this.isApprovalStatus = true;
         this.productForm.disable();
      } else {
        this.isApprovalStatus = false;
        this.productForm.enable();
        this.status = response;
        console.log('status data:', this.status);
      }
    },
    (error) => {
      console.error('Error fetching approval status:', error);
      this.isApprovalStatus = true;
    }
  );
}
  
  fetchSkusBySection(sectionId: number) {
  this.apiService.skubystore(sectionId).subscribe(
    (response) => {
      this.productList = response;
       console.log('product data:', this.productList);
    },
    (error) => {
      console.error('Error fetching SKUs by Section ID:', error);
      this.productList = [];
    }
  );
}

//   fetchServiceBySectionId(sectionId: number) {
//   this.apiService.getServiceBySection(sectionId).subscribe(
//     (response) => {
//       this.productList = response;
//        console.log('product dataaaa:', this.productList);
//     },
//     (error) => {
//       console.error('Error fetching SKUs by Section ID:', error);
//       this.productList = [];
//     }
//   );
// }
//  fetchCombinedData(section:any) {
//   this.apiService.skubystore(section).subscribe(
//     (skuResponse) => {
//       this.apiService.getServiceBySection(section).subscribe(
//         (serviceResponse) => {
//           if (skuResponse.length > 0) {
//             this.combinedDropdownData = [
//               { category: 'SKU', items: skuResponse.map(item => ({ ...item, type: 'SKU' })) },
//               { category: 'Service', items: serviceResponse.map(item => ({ ...item, type: 'Service' })) }
//             ];
//           } else {
//             this.combinedDropdownData = [
//               { category: 'Service', items: serviceResponse.map(item => ({ ...item, type: 'Service' })) }
//             ];
//           }
//         },
//         (error) => console.error('Error fetching service data:', error)
//       );
//     },
//     (error) => {
//       console.error('Error fetching SKU data:', error);
//       this.apiService.getServiceBySection(section).subscribe(
//         (serviceResponse) => {
//           this.combinedDropdownData = [
//             { category: 'Service', items: serviceResponse.map(item => ({ ...item, type: 'Service' })) }
//           ];
//         },
//         (serviceError) => console.error('Error fetching service data:', serviceError)
//   );
// }
//   );
// }
  // onSelectionChange(selected: any) {
  //   this.sku_id = selected;
  //   this.fetchhsnno(selected);
  //   this.productForm.patchValue({ sku_id: selected });
  // }
  // fetchhsnno(data: any) {
  //   this.apiService.gethsnno(data,'Purchase').subscribe(
    fetcHsnDetails(data: any) {
    this.apiService.getItemDetails(data, 'Purchase').subscribe(
      (response) => {
        if (!response.success) {
          alert(response.message || 'Unable to fetch item details.');
          return;
        }
        let missingFields = [];
        if (!response.price || response.price <= 0) missingFields.push('Price');
        if (!response.ledger_id || !response.ledger_name) missingFields.push('Ledger');
        if (!response.hsn_no) missingFields.push('HSN No');
        if (!response.unit_id) missingFields.push('UOM');

        if (missingFields.length > 0) {
            alert(`Cannot select this item! The following details are missing in the SKU Master: ${missingFields.join(', ')}. Please update the SKU first.`);
            this.productForm.patchValue({ sku_id: null });
            this.item_id = null;
            this.dataControl.setValue('');
            return;
        }

        this.productForm.patchValue({
          hsn_no: response.hsn_no,
          ledger_name: response.ledger_name,
          ledger_id: response.ledger_id,
          uom: response.unit_name,
          unit_id: response.unit_id,
          specification: response.description,
          store_data: response.store_name,
          store_id: response.store_id,
          price: response.price,
          sku_name: response.sku_name,
          item_name: response.item_name,
          item_id: response.item_id,
          profit_cost_name: response.profit_cost_name,
          profit_cost_id: response.profit_cost_id,
          branch_name: response.branch_name,
          branch_id: response.branch_id,
          type: response.item_service_type,
          category_name:response.category_name,
          category_id:response.category_id
        });
        const selectedUom = this.unit_data.find(u => u.id === response.unit_id);
        if (selectedUom) {
          this.productForm.patchValue({
            uom: selectedUom
          });
        }
        this.isHsnNo = true;
        this.isUom = true;
        this.isSpecification = true;
        this.isStore = true;
        this.isPrice = true;
        this.isSku = true;
      },
      (error) => {
        console.error(' error');
          alert(error?.error?.message);
      }
    );
  }
  fetcSacDetails(filteredServices:any,profit_cost:any,section:any) {
    this.apiService.getServiceDetails(filteredServices,profit_cost,section,'Purchase').subscribe(
      (response) => {
        let missingFields = [];
        if (!response.ledger_id || !response.ledger_name) missingFields.push('Ledger');
        if (!response.hsn_no) missingFields.push('SAC Code');

        if (missingFields.length > 0) {
            alert(`Cannot select this service! The following details are missing: ${missingFields.join(', ')}. Please update the Service Master first.`);
            this.productForm.patchValue({ selectedServiceId: null });
            this.selectedServiceId = null;
            return;
        }

        this.productForm.patchValue({
        hsn_no: response.hsn_no,
        ledger_name: response.ledger_name,
        ledger_id: response.ledger_id,
        uom: response.unit_name,
        unit_id: response.unit_id,
        specification: response.description,
        store_data:response.store_name,
        store_id: response.store_id,
        price: response.price,
        service_name: response.service_name,
        type:response.item_service_type,
        profit_cost_name:response.profit_cost_name,
        profit_cost_id:response.profit_cost_id,
        branch_name:response.branch_name,
        branch_id:response.branch_id,
        service_id:response.service_id,
        category_name:response.category_name,
        category_id:response.category_id
        });
        const selectedUom = this.unit_data.find(u => u.id === response.unit_id);
        if (selectedUom) {
          this.productForm.patchValue({
            uom: selectedUom
          });
        }
        this.isHsnNo = true;
        this.isUom = true;
        this.isSpecification = true;
        this.isStore=true;
        this.isPrice = true;
        this.isSku = true;
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
        alert(error?.error?.message);
      }
    );
  }
  onRequisitionDateChange(): void {
    if (!this.requesition_date || !this.selectedProfitCosts) return;
    const data = {
      profit_cost_id: this.selectedProfitCosts,
      purchase_date: this.requesition_date
    };
    this.apiService.validateRequisitionDate(data).subscribe(
      (res: any) => {
        console.log('response',res);
      },
      (err: any) => {
        alert(err?.error?.message || err?.message );  
        this.requesition_date = null;
      }
    );
  }

  Requisition(exitAfterSave?: 'close' | 'view'): void {
    if (!this.selectedProfitCosts || !this.requesition_date || !this.selectedDate) {
      alert('Please fill all required fields.');
      return;
    }
    if (!this.products || this.products.length === 0) {
      alert('Please add at least one product.');
      return;
    }
    if (this.products.some(p => p.isEditing)) {
      alert('Please save the editing line item first before saving the document.');
      return;
    }

    if (this.document_type == 'Goods'){
      if (!this.store_data){
        alert('Please select store.');
        return;
      }
    }

    const postData = {
      store: this.store_data || null,
      requisition_date: this.requesition_date,
      purchase_date: formatDate(this.selectedDate, 'yyyy-MM-dd', 'en-IN'),
      req_no: this.req_no || null,
      products: this.products.map(product => ({
        ...product,
        unit_id: product.unit_id || null,
        value: parseFloat((product.quantity * product.price).toFixed(2)),
      })),
      profit_cost_id: this.selectedProfitCosts || null,
      section_id:this.selectedSections|| null,
      document_type: this.document_type || null,
      branch_id:this.branch || null,
      remark:this.remark || null,
    };

    console.log('Post Data:', postData);
    // return;
    if (this.data?.id) {
      this.apiService.updateRequisition(this.data.id, postData).subscribe(
        (response: any) => {
          console.log('Requisition updated successfully:',response);
          if (response.status === false) {
            alert(response.message);
            return;
          }
          alert(response.message);
          if (exitAfterSave === 'close') {
            this.dialogRef.close({ id: this.data.id, action: 'update' });
          } else {
            this.enterViewMode();
          }
        },
        error => {
          console.error('Error updating Requisition:', error);
               if (error.error && error.error.message) {
            alert(error.error.message);
          } else {
            alert('An unexpected error occurred while updating requisition.');
          }
        }
      );
    } else {
      this.apiService.createRequisition(postData).subscribe(
        (response: any) => {
          console.log('Requisition API Response:', response);
          if (response.status) {
            alert(response.message || 'Requisition created successfully');
            this.dialogRef.close({ id: response.data.id, action: 'create' });
          } else {
            alert(response.message || 'Failed to create requisition');
          }
        },
        (error) => {
          console.error('Error creating requisition:', error);
          if (error.error && error.error.message) {
            alert(error.error.message);
          } else {
            alert('An unexpected error occurred while creating requisition.');
          }
        }
      );
    }
  }
//   recalculateLedgerValues(): Promise<void> {
//     return new Promise((resolve, reject) => {
//       if (!this.selectedDate) {
//         alert('Please select purchase date.');
//         return reject('No purchase date selected');
//       }

//       const ledgerMap = new Map<string, { category_name: string; total: number }>();

//       console.log('this.products',this.products);

//       this.products.forEach(product => {
//         console.log('product',product);
//         if (product.category_id && product.category_name && product.quantity && product.price) {
//           const value = product.quantity * product.price;
//           const existing = ledgerMap.get(product.category_id);
//           if (existing) {
//             existing.total += value;
//           } else {
//             ledgerMap.set(product.category_id, {
//               category_name: product.category_name,
//               total: value
//             });
//           }
//         }
//       });
//       console.log('ledgerMap',ledgerMap);

//       const initialLedgerSummary = Array.from(ledgerMap.entries()).map(([category_id, data]) => ({
//         category_id,
//         category_name: data.category_name,
//         total: data.total,
//       }));
//       console.log('initialLedgerSummary',initialLedgerSummary);
//       const selectedDate = moment(this.selectedDate).startOf('day');
//       const skuIds = this.products.map((p: any) => p.sku_id).filter(Boolean);

//       this.apiService.getCategorybudget().subscribe({
//         next: (response) => {
//           this.budget_data = response?.data || [];
//           const uniqueLedgerIds = new Set(initialLedgerSummary.map(s => s.category_id));
//           console.log('uniqueLedgerIds',uniqueLedgerIds);
//           this.ledgerSummary = Array.from(uniqueLedgerIds).map((category_id: any) => {
//             const summary = initialLedgerSummary.find(s => s.category_id === category_id) || {
//               category_id,
//               category_name: this.budget_data.find(b => b.category_id === category_id)?.category_name || 'Unknown',
//               total: null,
//               requisition_approved: null
//             };
// // alert(this.selectedProfitCosts);
//             const matchedBudget = this.budget_data.find((b: any) => {
//               const from = moment(b.from_date).startOf('day');
//               const to = moment(b.to_date).endOf('day');
//               return b.category_id === category_id && selectedDate.isBetween(from, to, undefined, '[]') && b.profit_cost_id === this.selectedProfitCosts;
//             });
//             console.log('summary',summary);
//             return {
//               ...summary,
//               total_budget: matchedBudget?.dr_amount,
//             };
//           });

//           const missingCategoriesBudget = this.ledgerSummary
//             .filter(s => s.total_budget == null) // null or undefined
//             .map(s => s.category_name || `Category ID: ${s.category_id}`);

//           if (missingCategoriesBudget.length > 0) {
//             alert(`No total budget found for: ${missingCategoriesBudget.join(', ')}`);
//             return reject('Missing budget for some categories');
//           }
          
//           console.log('this.ledgerSummary',this.ledgerSummary);
//           this.apiService.getRequisition().subscribe({
//             next: (req) => {
//               this.req_data = req || [];
//               console.log('this.req_data',this.req_data);
//               if (this.req_data.length > 0) {
//                 this.calculateApprovedRequisitions();
//               }
//               this.apiService.getPo().subscribe({
//                 next: (po) => {
//                   console.log('po',po);
//                   this.poData = po?.data || [];
//                   // this.poData = rawPoData.filter((poItem: any) =>
//                   //   poItem.po_details?.some((detail: any) => skuIds.includes(detail.sku_id))
//                   // );
//                   console.log('this.poData',this.poData);
//                   if (this.req_data.length === 0 || this.poData.length > 0) {
//                     this.calculateApprovedRequisitions();
//                   }
//                   resolve();
//                 },
//                 error: () => {
//                   console.log('error');
//                   if (this.req_data.length === 0) {
//                     this.poData = [];
//                     this.calculateApprovedRequisitions();
//                   }
//                   resolve();
//                 }
//               });
//             },
//             error: () => {
//               this.req_data = [];

//               this.apiService.getPo().subscribe({
//                 next: (po) => {
//                   console.log('po',po);
//                   this.poData = po?.data || [];
//                   // this.poData = rawPoData.filter((poItem: any) =>
//                   //   poItem.po_details?.some((detail: any) => skuIds.includes(detail.sku_id))
//                   // );
//                   console.log('this.poData',this.poData);
//                   this.calculateApprovedRequisitions();
//                   resolve();
//                 },
//                 error: (poError) => {
//                   console.log('poError',poError);
//                   console.error('Error fetching PO after Req failed:', poError);
//                   this.poData = [];
//                   this.calculateApprovedRequisitions();
//                   resolve();
//                 }
//               });
//             }
//           });
//         },
//         error: (budgetError) => {
//           console.error('Error fetching budget data:', budgetError);
//           reject(budgetError);
//         }
//       });
//     });
//   }

private rebuildCurrentRequisition(): void {
  const categoryMap = new Map<number, any>();

  this.products.forEach((product: any) => {
    const categoryId = Number(product.category_id);

    if (!categoryId) {
      return;
    }

    const amount =
      (Number(product.quantity) || 0) *
      (Number(product.price) || 0);

    if (categoryMap.has(categoryId)) {
      categoryMap.get(categoryId).amount += amount;
    } else {
      categoryMap.set(categoryId, {
        category_id: categoryId,
        category_name: product.category_name,
        amount: amount
      });
    }

  });
  this.current_requisition = Array.from(categoryMap.values());
  this.category_ids = Array.from(categoryMap.keys());

}


  calculateApprovedRequisitions(): void {
    this.ledgerSummary = this.ledgerSummary.map(summary => {
      let openReqValue = 0;
      let sendForApprovalValue = 0;
      let approvalValue = 0;
      let openPoValue = 0;
      let sendForPoApprovalValue = 0;
      let poApproved = 0;
      let totalValue = 0;
      this.req_data.forEach((req: any) => {
        console.log('this.req_data',this.req_data);
        const details = Array.isArray(req.req_details) ? req.req_details : [];
        details.forEach((detail: any) => {
          if (Number(detail.stock_keeping?.profit_cost_category?.category_id) === Number(summary.category_id) && req.profit_cost_id ==this.selectedProfitCosts) {
            const qty = Number(detail.qty) || 0;
            const price = Number(detail.price) || 0;
            const value = qty * price;
            const status = String(req.status);
            if (req.approval_status === null || req.approval_status === 'Open') {
              openReqValue += value;
            } else if (req.approval_status === 'Pending') {
              sendForApprovalValue += value;
            } else if (req.approval_status === 'Approved') {
              approvalValue += value;
            }
          }
        });
      });
      this.poData.forEach((po: any) => {
        const poDetails = Array.isArray(po.po_details) ? po.po_details : [];
        poDetails.forEach((detail: any) => {
          console.log('detailssssssssssssss',detail);
          console.log('summaryyyyyyyyyy',summary);
          // const matchedProduct = this.products.find(p => Number(p.sku_id?.id || p.sku_id) === Number(detail.sku_id));
          if (Number(detail.stock_keeping?.profit_cost_category?.category_id) === 
          Number(summary.category_id) && po.profit_cost_id ==this.selectedProfitCosts) {
            const qty = Number(detail.qty) || 0;
            const price = Number(detail.unit_price) || 0;
            const value = qty * price;
            totalValue += value;
            if (po.approval_status === null || po.approval_status === 'Open') {
              openPoValue += value;
            } else if (po.approval_status === 'Pending') {
              sendForPoApprovalValue += value;
            } else if (po.approval_status === 'Approved') {
              poApproved += value;
            }
          }
        });
      });
      const shouldSetApprovedToZero = openPoValue > 0 || sendForPoApprovalValue > 0 || poApproved > 0;
      const available = totalValue;
      return {
        ...summary,
        open_requisition: openReqValue > 0 ? openReqValue : 0,
        send_for_approval: sendForApprovalValue > 0 ? sendForApprovalValue : 0,
        approved: shouldSetApprovedToZero ? 0 : approvalValue,
        open_po: openPoValue > 0 ? openPoValue : 0,
        send_for_po_approval: sendForPoApprovalValue > 0 ? sendForPoApprovalValue : 0,
        po_approved: poApproved > 0 ? poApproved : 0,
        available_budget: summary.total_budget - available,
        balance: summary.total_budget - (summary.total +
          openPoValue +
          sendForPoApprovalValue +
          poApproved)
      };
    });
    console.log('Ledger Summary1:', this.ledgerSummary);
  }
  // fetchReqData() {
  //   this.apiService.getRequisition().subscribe(
  //     (response) => {
  //       this.req_data = response;
  //       this.fetchPoData();
  //     },
  //     (error) => {
  //       console.error('Error fetching requisitions:', error);
  //     }
  //   );
  // }
  // fetchPoData(): void {
  //   const skuIds = this.products
  //     .map((product: any) => product.sku_id?.id)
  //     .filter((id: any) => !!id);

  //   this.apiService.getPo().subscribe(
  //     (response) => {
  //       this.poData = response.data;
  //       // this.poData = allPoData.filter((po: any) =>
  //       //   po.po_details?.some((detail: any) => skuIds.includes(detail.sku_id))
  //       // );
  //       console.log('Filtered PO Data:', this.poData);
  //       this.fetchReqData();
  //     },
  //     (error) => {
  //       console.error('Error fetching PO data:', error);
  //     }
  //   );
  // }

  fetchBranchData() {
    if (this.loading || !this.hasMore) return;
    this.loading = true;
    // this.apiService.getDatabranch().subscribe(
    //   (response) => {
    //     this.branchdata = response;
    //     console.log('Data from :', this.data);
    //   },
    //   (error) => {
    //     console.error('Error fetching data:', error);
    //   }
    // );
    this.apiService.getDatabranch({
    type:"lazyloading",
    offset: this.offset,
    limit: this.limit,
    search: this.branchSearch || undefined,
    branch_id: this.branch || null,
  }).subscribe(
    (response: any) => {
      const data = response?.branch_data ?? response ?? [];
      data.forEach((b: any) => {
      this.branchNameMap.set(b.id, b.name);
    });
       if (this.offset === 0) {
        this.branchdata = data;              
      } else {
        this.branchdata = [...this.branchdata, ...data];
      }

      this.offset += data.length;             

      if (data.length < this.limit) {
        this.hasMore = false;               
      }
      this.loading = false;
      this.cdr.detectChanges();
    },
    () => this.loading = false
  );
  }
  // onBranchSelect(branch_id: any) {
  //   //  this.selectedProfitCosts = null;
  //   //   this.selectedSections=null;
  //   //   this.store_data=null;
  //   //   this.filtered_item_data=[];
  //   //   this.filtered_fa_item_data=[];
  //   //   this.fa_item_data=[];
  //   //   this.item_data=[];
  //   //   this.products=[];
  //     // this.productForm.reset();
  //     // this.productForm.patchValue({
  //     //  start_date: this.today,
  //     // });
  //   this.resetFields([
  //     'branch'
  //   ]);
  //     this.selectedbranch = branch_id;
  //   // if (this.document_type !== 'Goods') {
  //     this.fetchProfitCostData();
  //   // }else{
  //   //   this.fetchProfitCostData();
  //   // }
  // }
    onBranchSelect(branch_id: any) {
    if (this.previousBranch === undefined) {
      this.previousBranch = this.selectedbranch || branch_id;
    }
    if (!this.isInputDisabled && this.previousBranch !== branch_id) {
      console.log('create');
    this.selectedProfitCosts = null;
    this.profitCostOffset = 0;
    this.profitCostHasMore = true;
    this.PcCcData = [];
    this.branch = branch_id;
    this.selectedbranch = branch_id;
    this.previousBranch = branch_id;
    this.fetchProfitCostData();
  // onBranchSelect(branch_id: any) {
  //   //  this.selectedProfitCosts = null;
  //   //   this.selectedSections=null;
  //   //   this.store_data=null;
  //   //   this.filtered_item_data=[];
  //   //   this.filtered_fa_item_data=[];
  //   //   this.fa_item_data=[];
  //   //   this.item_data=[];
  //   //   this.products=[];
  //     // this.productForm.reset();
  //     // this.productForm.patchValue({
  //     //  start_date: this.today,
  //     // });
  //   this.resetFields([
  //     'branch'
  //   ]);
  //     this.branch = branch_id;
  //     this.profitCostOffset = 0;
  //     this.profitCostHasMore = true;
  //     this.loadingProfitCost = false;
  //     this.PcCcData = [];     
  //     // this.selectedbranch = branch_id;
  //   // if (this.document_type !== 'Goods') {
  //     this.fetchProfitCostData();
  //   // }else{
  //   //   this.fetchProfitCostData();
  //   // }
  // }

      const proceedChange = () => {
        if (confirm('Changing Branch will clear selected data. Do you want to continue?')) {
          this.resetFields(['branch']);
          this.selectedbranch = branch_id;
          this.previousBranch = branch_id;
          this.fetchProfitCostData();
        } else {
          console.log('Branch change cancelled1');
          setTimeout(() => {
            this.branch = this.previousBranch;
            this.selectedbranch = this.previousBranch;
          });
          this.fetchProfitCostData();
        }
      };
      // proceedChange();
      if (this.isInputDisabled && this.data.approval_status === 'Open') {
        const skuIds = this.products?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];

        this.apiService.checkNextDocument({
          doc_id: this.data.id,
          model: 'Requisition',
          sku_id: skuIds
        }).subscribe((res: any) => {
          if (res.status === false) {
            alert('Next document created. Cannot change branch.');
            setTimeout(() => {
              this.branch = this.previousBranch;
              this.selectedbranch = this.previousBranch;
            });
          } else {
            proceedChange();
          }
        });
      }

    } else {
      console.log('Branch change cancelled3');
      this.previousBranch = branch_id;
      this.resetFields(['branch']);
      this.selectedbranch = branch_id;
      this.fetchProfitCostData();
    }
  }
    sendForApprove() {
      if (!this.calculated_budget || Object.keys(this.calculated_budget).length === 0) {
       alert('Document cannot be sent for approval. Please click the calculate button once.');
        return;
      }
        this.rebuildCurrentRequisition();

      // if(this.document_type === 'Services'){
      //   const requestData = {
      //     document_type: 'Requisition',
      //     document_id: this.data.id,
      //     profit_cost_id: this.data.profit_cost_id,
      //   };

      //   this.apiService.sendForApproval(requestData).subscribe(
      //     (approvalResponse) => {
      //       console.log('Requisition sent for approval:', approvalResponse);
      //       alert('Document sent for approval');
      //       //this.dialogRef.close(this.data.id,'approvalsend');
      //       this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
      //     },
      //     (approvalError) => {
      //       console.error('Error sending requisition for approval:', approvalError);
      //       alert('Error sending requisition for approval: ' + approvalError);
      //     }
      //   );
      // }else if(this.document_type === 'Goods'){
    // First fetch the budget data to validate before sending for approval
    const budgetData = {
      requisition_type:this.document_type,
      pc_cc_id: this.selectedProfitCosts,
      category_ids: this.category_ids,
      date: this.selectedDate,
      current_requisition: this.current_requisition,
      requisition_id:this.data?.id,
    };

    this.apiService.calculateBudget(budgetData).subscribe(
      (response) => {
        if (response.status) {
          const budgetInfo = response.data;
          
          // Check if any category has negative balance
          const negativeBalanceCategories = [];
          for (const categoryKey in budgetInfo) {
            const category = budgetInfo[categoryKey];
            if (category.balance < 0) {
              negativeBalanceCategories.push(category.category_name || categoryKey);
            }
          }

          if (negativeBalanceCategories.length > 0) {
            alert(`Budget exceeded for the following categories: ${negativeBalanceCategories.join(', ')}. Cannot send for approval.`);
            return;
          }

          // If all budgets are valid, proceed with sending for approval
          if (confirm('Do you want to send this document for approval?')) {
          const requestData = {
            document_type: 'Requisition',
            document_id: this.data.id,
            profit_cost_id: this.data.profit_cost_id,
          };

          this.apiService.sendForApproval(requestData).subscribe(
            (approvalResponse:any) => {
              console.log('Requisition sent for approval:', approvalResponse);
              if(approvalResponse.status == false){
                alert(approvalResponse.message);
              }else{
              alert('Document sent for approval successfully.');
              }
              //this.dialogRef.close(this.data.id,'approvalsend');
              this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
            },
            (approvalError) => {
              console.error('Error sending requisition for approval:', approvalError);
              alert('Error sending requisition for approval: ' + approvalError.error.message);
            }
          );
        }
      } else {
        alert(response.message || 'Failed to fetch budget data');
      }
    },
    (budgetError) => {
      console.error('Error fetching budget data:', budgetError);
      // alert('Document cannot be sent for approval. Please click the calculate button once.');
         alert('Error fetching budget data. Cannot proceed with approval.');
    }
  );
}

  showApprovalTimeline() {
    const requestData = {
      document_type: 'Requisition',
      document_id: this.data.id,
    };

    this.apiService.getApprovalTimeline(requestData).subscribe(
      (response) => {
        console.log('Approval timeline data:', response);
        
        // Open approval timeline dialog with real data
        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: response.data || response }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      },
      (error) => {
        console.error('Error fetching approval timeline:', error);
        
        // Fallback to demo data if API fails
        const demoApprovalData: ApprovalTimelineData = {
          document_id: this.data.id || 12345,
          document_type: 'Requisition',
          current_stage: 2,
          total_stages: 4,
          overall_status: 'pending',
          created_at: new Date().toISOString(),
          created_by: 'Current User',
          stages: [
            {
              id: 1,
              name: 'Department Head Review',
              level: 1,
              status: 'approved',
              approver_name: 'Sarah Johnson',
              approved_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
              comments: 'All requirements met, approved for next level',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 2,
              name: 'Finance Manager Review',
              level: 2,
              status: 'pending',
              is_current: true,
              timeline: [],
              pending_time_seconds: 7200,
              pending_time_formatted: '2h 0m 0s',
              cancellation_count: 0
            },
            {
              id: 3,
              name: 'General Manager Approval',
              level: 3,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 4,
              name: 'Final Approval',
              level: 4,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            }
          ]
        };

        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: demoApprovalData }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      }
    );
  }

  calculateBudget(){
    if (!this.selectedDate) {
      alert('Please select Month and Year');
      return;
    }
    this.rebuildCurrentRequisition(); 
      const data={
        requisition_type:this.document_type,
        pc_cc_id:this.selectedProfitCosts,
        category_ids:this.category_ids,
        date:this.selectedDate,
        current_requisition:this.current_requisition,
        requisition_id:this.data?.id,
      }
      this.apiService.calculateBudget(data).subscribe((response)=>{
        if(response.status){
        this.calculated_budget = response.data
        console.log('response', response.data);
        this.isBudgetDirty = false;
        }else{
          alert(response.message);
        }
      }, (error) => {
        console.error('Error calculating budget:', error);
      });
      console.log('data', data);
  }
  filterItems() {
    const searchValue = this.dataControl.value;
    if (!searchValue || searchValue.toString().trim() === '') {
      if(this.document_type === 'Goods'){
      this.filtered_item_data = this.item_data.slice();
      return;
      }else if(this.document_type === 'Fixed Asset'){
        this.filtered_fa_item_data = this.fa_item_data.slice();
        return;
      }
    }
    const searchTerm = searchValue.toString().toLowerCase();
    if(this.document_type === 'Goods'){
    this.filtered_item_data = this.item_data.filter(item =>
      item.item_name && item.item_name.toLowerCase().includes(searchTerm)
    );
  }else if(this.document_type === 'Fixed Asset'){
    this.filtered_fa_item_data = this.fa_item_data.filter(item =>
      item.name && item.name.toLowerCase().includes(searchTerm)
    );
  }
    console.log('filtered_item_data', this.filtered_item_data);
  }
  displayFn(item: any): string {
    return typeof item === 'string' ? item : (item && item.item_name ? item.item_name : '');
  }

  viewRelatedDocuments(requisitionId: number): void {
    const payload = {
      document_id: requisitionId,
      document_type: "requisition"
    };

    // Show loading state
    const loadingDialog = this.dialog.open(DocumentTracingModalComponent, {
      width: '90%',
      maxWidth: '1200px',
      height: '80%',
      maxHeight: '800px',
      disableClose: false,
      data: {
        tracingData: null,
        loading: true
      }
    });

    this.apiService.getDocumentTracing(payload).subscribe(
      (response) => {
        if (response.status) {
          // Close loading dialog and open with data
          loadingDialog.close();

          const dialogRef = this.dialog.open(DocumentTracingModalComponent, {
            width: '90%',
            maxWidth: '1200px',
            height: '80%',
            maxHeight: '800px',
            disableClose: false,
            data: {
              tracingData: response.data,
              loading: false
            }
          });

          dialogRef.afterClosed().subscribe(() => {
            console.log('Document tracing modal closed');
          });
        } else {
          loadingDialog.close();
          alert('Error: ' + response.message);
        }
      },
      (error) => {
        loadingDialog.close();
        console.error('Error fetching document tracing:', error);

        let errorMessage = 'Error fetching related documents. Please try again.';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        alert(errorMessage);
      }
    );
  }
  fetchunitData() {
    this.adminService.getGlobalUnit().subscribe(
      (response) => {
        this.unit_data = response;
        console.log('UNIT data:', this.unit_data);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  checkReorderLevel(qty: number) {
    qty = Number(qty);

    if (this.filteredSkus && this.filteredSkus.length > 0) {
      const sku = this.filteredSkus[0];
      if (sku && sku.sku_detail_maps) {
        const sectionMap = sku.sku_detail_maps.find(
          (map: any) => Number(map.section_id) === Number(this.selectedSections)
        );
        const found = this.filteredSections?.find((item: any) => item.id === (this.data?.section_id || this.selectedSections));

        if (sectionMap && sectionMap.reorder_level > 0 && qty > sectionMap.reorder_level) {
          const sectionName = found ? found.section_name : '';
          alert(`Quantity (${qty}) is above reorder level (${sectionMap.reorder_level}) for section ${sectionName}`);
          this.productForm.patchValue({ quantity: null });
        }
      }
    }
  }
  fetchFaItemData() {
    this.apiService.getFaTemplate().subscribe(
      (response) => {
        this.fa_item_data = response.data;
        this.filtered_fa_item_data = [...this.fa_item_data];
        console.log('Fa item Data from API:', this.fa_item_data);
      },
      (error) => {
        console.error('Error fetching Fa item data:', error);
        this.fa_item_data = [];
      }
    );
  }
  onFaItemChange(itemId: number) {
    const selectedItem = this.fa_item_data.find(item => item.id === itemId);
    const selectedBranch = this.branchdata.find(
      (branch: any) => branch.id === this.branch
    );
    const selectedProfitCost = this.PcCcData.find(
      (profitCost: any) => profitCost.id === this.selectedProfitCosts
    );
    if (selectedItem) {
      let missingFields = [];
      if (!selectedItem.hsn?.hsn_sac_no) missingFields.push('HSN No');
      if (!selectedItem.ledger_id || !selectedItem.ledger_name) missingFields.push('Ledger');
      
      if (missingFields.length > 0) {
          alert(`Cannot select this Fixed Asset! The following details are missing: ${missingFields.join(', ')}. Please update the Fixed Asset Template.`);
          this.dataControl.setValue('');
          this.item_id = null;
          return;
      }
      this.dataControl.setValue(selectedItem.name);
      this.filterItems();
    }

    if (this.document_type === 'Fixed Asset') {
      this.productForm.patchValue({ quantity: 1 });
      this.productForm.get('quantity')?.disable();
    } else {
      this.productForm.get('quantity')?.enable();
    }


    console.log('selectedItem', selectedItem);
    this.item_id = itemId;

    this.productForm.patchValue({
      branch_name: selectedBranch.name,
      branch_id: selectedBranch.id,
      profit_cost_name: selectedProfitCost.name,
      profit_cost_id: selectedProfitCost.id,
      name: selectedItem.name,
      item_id: selectedItem.id,
      sku_id: selectedItem.id,
      hsn_no: selectedItem.hsn?.hsn_sac_no,
      uom: selectedItem.unit?.unit_name,
      unit_id: selectedItem.unit_id,
      type: 'Fixed Asset',
      category_name: selectedItem?.home_entity_category?.category_name,
      category_id: selectedItem?.home_entity_category?.id,
      ledger_id: selectedItem?.ledger_id,
      ledger_name: selectedItem?.ledger_name,
    });
    this.isHsnNo = true;
    const selectedUom = this.unit_data.find(u => u.id === selectedItem.unit_id);
    if (selectedUom) {
      this.productForm.patchValue({
        uom: selectedUom
      });
    }
  }

  resetFields(excludedFields: string[] = []) {
    const defaultValues: any = {
      branch: null,
      selectedProfitCosts: null,
      selectedSections: null,
      store_data: null,
      filtered_item_data: [],
      filtered_fa_item_data: [],
      fa_item_data: [],
      item_data: [],
      products: [],
      service_data: [],
      filteredServices: [],
    };

    for (const key in defaultValues) {
      if (!excludedFields.includes(key)) {
        (this as any)[key] = defaultValues[key];
      }
    }

    if (!excludedFields.includes('productForm')) {
      this.productForm.reset();
      this.productForm.patchValue({
        start_date: this.today,
      });
    }
  }
  exportDetails() {
    if (!this.products || this.products.length === 0) {
      alert('No products to export');
      return;
    }

    console.log(this.products);

    const dataToExport = this.products.map(p => {
      let itemServiceName = '';
      if (p.type === 'SKU') {
        itemServiceName = p.item_name;
      } else if (p.type === 'Service') {
        itemServiceName = p.service_name;
      } else if (p.type === 'Fixed Asset') {
        itemServiceName = p.asset_name;
      } else {
        itemServiceName = '';
      }
      return {
        'Type': p.type,
        'Item/Service Name': itemServiceName,
        'Category': p.category_name,
        'HSN No': p.hsn_no,
        'Specification': p.specification,
        'Comment': p.description,
        'Quantity': p.quantity,
        'UOM': p.uom,
        'Price': p.price,
        'Amount': (Number(p.quantity) * Number(p.price)).toFixed(2),
        'Delivery Date': p.end_date ? moment(p.end_date).format('DD-MM-YY') : ''
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Requisition Details');
    const fileName = `Requisition_Details_${this.req_no || 'Draft'}_${moment().format('YYYYMMDD_HHmmss')}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  }
  lineItemSample() {
    this.apiService.lineItemSample(this.document_type).subscribe(
      (response: any) => {
        const downloadUrl = response.downloadUrl;
        console.log('Download URL:', downloadUrl);

        if (downloadUrl) {
          const downloadLink = document.createElement('a');
          downloadLink.href = downloadUrl;
          downloadLink.download = 'line_item_sample.xlsx';
          downloadLink.target = '_blank';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } else {
          console.error('Download URL not provided in API response');
        }
      },
      error => {
        console.error('Error exporting item:', error);
      }
    );
  }
  prepareProductObject(data: any, isFromImport: boolean = false): any {
    const pcId = isFromImport ? this.selectedProfitCosts : data.profit_cost_id;
    const branchId = isFromImport ? this.selectedbranch : data.branch_id;

    return {
      sku_id: data.sku_id || data.service_id,
      service_id: data.service_id || null,
      hsn_no: data.hsn_no || '',
      specification: data.specification || '',
      description: data.description || '',
      uom: data.unit_name || data.uom?.unit_name || '',
      unit_id: data.uom?.id || data.unit_id,
      quantity: (this.document_type === 'Fixed Asset') ? 1 : Number(data.qty || data.quantity || 0),
      price: Number(data.price) || 0,
      discount: Number(data.discount) || 0,
      start_date: isFromImport ? this.today : data.start_date,
      end_date: isFromImport ? (data.delivery_date ? moment(data.delivery_date, ['DD-MM-YYYY']).format('YYYY-MM-DD') : '') : data.end_date,
      ledger_name: data.ledger_name || '',
      ledger_id: data.ledger_id || '',
      sku_name: data.sku_name || '',
      item_id: data.item_id || '',
      item_name: data.item_name || '',
      profit_cost_id: pcId,
      profit_cost_name: isFromImport ? data.profit_cost_name : data.profit_cost_name,
      branch_id: branchId,
      branch_name: isFromImport ? data.branch_name : data.branch_name,
      type: data.item_service_type || data.type,
      service_name: data.service_name || '',
      category_name: data.category_name,
      category_id: data.category_id,
      section_id: this.selectedSections,
      name: data.name || data.sku_name || data.item_name,
    };
  }

  commonProductAddLogic(product: any) {
    if (product.category_id && !this.category_ids.includes(product.category_id)) {
      this.category_ids.push(product.category_id);
    }

    if (product.category_id) {
      const existingReqIndex = this.current_requisition.findIndex(
        req => Number(req.category_id) === Number(product.category_id)
      );

      const amount = Number(product.quantity) * Number(product.price);
      if (existingReqIndex > -1) {
        this.current_requisition[existingReqIndex].amount += amount;
      } else {
        this.current_requisition.push({
          category_id: product.category_id,
          category_name: product.category_name,
          amount: amount,
        });
      }
    }
    this.products.push(product);
  }

  lineItemImport() {
    this.isUploading = true;
    const file = this.fileInput.nativeElement.files[0];
    if (!file) {
      this.isUploading = false;
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('document_type', this.document_type || '');
    formData.append('branch_id', this.selectedbranch || '');
    formData.append('profit_cost_id', this.selectedProfitCosts || '');
    formData.append('section_id', this.selectedSections || '');
    formData.append('date', this.selectedDate || '');
    formData.append('voucher_type', 'Purchase');
    this.apiService.lineItemImport(formData).subscribe(
      (response: any) => {
        if (response.status && response.data?.length) {
          response.data.forEach((item: any) => {
            if (!this.validateProduct(item, true)) {
              return;
            }
            const newProduct = this.prepareProductObject(item, true);
            this.commonProductAddLogic(newProduct);

            if (!this.store_data && item.store_id) {
              this.store_data = item.store_id;
            }
          });
          alert(response.message || 'Import successful');
        } else {
          alert(response.message || 'Import failed');
          if (response.download_link) {
            this.downloadErrorFile(response.download_link);
          }
        }
        this.resetUpload();
      },
      (error) => {
        console.error(error);
        const message =
          error?.error?.message ||
          error?.message ||
          'Error importing item. Please try again.';
        alert(message);
        if (error?.error?.download_link) {
          this.downloadErrorFile(error.error.download_link);
        }
        this.resetUpload();
      }
    );
  }
  resetUpload() {
    this.isUploading = false;
    this.fileInput.nativeElement.value = '';
  }
  downloadErrorFile(link: string) {
    const a = document.createElement('a');
    a.href = link;
    a.download = 'error_log.txt';
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

onBranchOpen(opened: boolean) {
  if (!opened) return;
  if (this.branchdata.length === 0) {
    this.offset = 0;
    this.hasMore = true;
    this.fetchBranchData();
  }

  Promise.resolve().then(() => {
    const panel = document.querySelector('.branch-select-panel') as HTMLElement;
    if (!panel) return;

    // panel.removeEventListener('scroll', this.onBranchScroll);
    panel.addEventListener('scroll', this.onBranchScroll);
  });
}
onBranchScroll = (event: any) => {
  const panel = event.target;

  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.hasMore &&
    !this.loading
  ) {
    this.fetchBranchData();
  }
};

onBranchSearch(value: string) {
  this.branchSearch = value;
  this.offset = 0;
  this.hasMore = true;
  this.branchdata = [];
  this.fetchBranchData();
}
onProfitCostOpen(opened: boolean) {
  if (!opened) {
    this.profitCostScrollAttached = false;
    return;
  }

  if (this.PcCcData.length === 0) {
    this.profitCostOffset = 0;
    this.profitCostHasMore = true;
    this.fetchProfitCostData();
  }

  Promise.resolve().then(() => {
    const panel = document.querySelector(
      '.profit-cost-select-panel'
    ) as HTMLElement;

    if (!panel || this.profitCostScrollAttached) return;

    panel.addEventListener('scroll', this.onProfitCostScroll);
    this.profitCostScrollAttached = true;
  });
}
onProfitCostScroll = (event: any) => {
  const panel = event.target;
  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.profitCostHasMore &&
    !this.loadingProfitCost
  ) {
    this.fetchProfitCostData();
  }
};
onProfitCostSearch(value: string) {
  this.profitCostSearch = value;
  this.profitCostOffset = 0;
  this.profitCostHasMore = true;
  this.PcCcData = [];
  this.fetchProfitCostData();
}
getBranchName(branchId: number | null): string {
  if (!branchId) return 'No branch selected';

  const branch = this.branchdata?.find(b => b.id === branchId);
  return branch ? branch.name : 'Unknown branch';
}
getProfitCostName(profitCostId: number | null): string {
  if (!profitCostId) return 'No profit cost selected';
  const profitCost = this.PcCcData?.find(pc => pc.id === profitCostId);
  return profitCost ? profitCost.name : 'Unknown profit cost';
}
getStoreName(storeId: number | null): string {
  if (!storeId) return 'No store selected';
  const store = this.store?.find(s => s.id === storeId);
  return store ? store.store_name : 'Unknown store';
}
getSectionName(sectionId: number | null): string {
  if (!sectionId) return 'No section selected';
  const section = this.filteredSections?.find(s => s.id === sectionId);
  return section ? section.section_name : 'Unknown section';    
}
onSectionSearch(search: string) {
  this.sectionSearch = search || '';
  this.sectionOffset = 0;
  this.sectionHasMore = true;
  this.filteredSections = [];
  this.fetchSection();
}
onSectionOpen(opened: boolean) {
  if (!opened) return;
  if (!this.selectedProfitCosts?.length) return;

  if (this.filteredSections.length === 0) {
    this.sectionOffset = 0;
    this.sectionHasMore = true;
    this.fetchSection();
  }
  Promise.resolve().then(() => {
    const panel = document.querySelector('.section-select-panel') as HTMLElement;
    if (!panel) return;
    panel.removeEventListener('scroll', this.onSectionScroll);
    panel.addEventListener('scroll', this.onSectionScroll);
  });
}
onSectionScroll = (event: any) => {
  const panel = event.target;
  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.sectionHasMore &&
    !this.sectionLoading
  ) {
    this.fetchSection();
  }
};

onEditItemChange(itemId: number, index: number) {
    this.products[index].item_id = itemId;
    this.apiService.skubystore(this.selectedSections).subscribe(
      (skuResponse: any) => {
        this.skuResponseData = skuResponse;

        const filteredSkus = this.skuResponseData.filter(
          (sku: any) => Number(sku.item_id) === Number(itemId)
        );

        if (filteredSkus.length > 0) {
          this.fetchEditHsnDetails(filteredSkus, index);
        }
        this.isBudgetDirty = true;
      },
      (error) => {
        console.error(error);
      }
    );

  }

  onEditServiceChange(serviceId: number, index: number) {
    this.products[index].selectedServiceId = serviceId;
    const filteredService = this.service_data.filter(
      (service: any) => Number(service.id) === Number(serviceId)
    );
    if (filteredService.length > 0) {
      this.fetchEditSacDetails(filteredService, index);
    }
    this.isBudgetDirty = true;

  }
fetchEditHsnDetails(data: any, index: number) {
  this.apiService.getItemDetails(data, 'Purchase').subscribe(
    (response: any) => {
      let missingFields = [];
      if (!response.price || response.price <= 0) missingFields.push('Price');
      if (!response.ledger_id || !response.ledger_name) missingFields.push('Ledger');
      if (!response.hsn_no) missingFields.push('HSN No');
      if (!response.unit_id) missingFields.push('UOM');

      if (missingFields.length > 0) {
          alert(`Cannot select this item! The following details are missing in the SKU Master: ${missingFields.join(', ')}. Please update the SKU first.`);
          this.products[index].item_id = '';
          this.products[index].sku_name = '';
          return;
      }
      const product = this.products[index];
      product.hsn_no = response.hsn_no;
      product.ledger_name = response.ledger_name;
      product.ledger_id = response.ledger_id;
      product.uom = response.unit_name;
      product.unit_id = response.unit_id;
      product.specification = response.description;
      product.store_id = response.store_id;
      product.store_name = response.store_name;
      product.price = response.price;
      product.sku_name = response.sku_name;
      product.sku_id = response.sku_id;
      product.item_name = response.item_name;
      product.item_id = response.item_id;
      product.category_name = response.category_name;
      product.category_id = response.category_id;
      product.type = response.item_service_type;
      this.products = [...this.products];
    },
    (error) => {
      console.error(error);
        alert(error?.error?.message);
    }
  );

}
fetchEditSacDetails(service,index){
    this.apiService.getServiceDetails(
        service,
        this.selectedProfitCosts,
        this.selectedSections,
        'Purchase'
    ).subscribe(res=>{
        let missingFields = [];
        if (!res.ledger_id || !res.ledger_name) missingFields.push('Ledger');
        if (!res.hsn_no) missingFields.push('SAC Code');

        if (missingFields.length > 0) {
            alert(`Cannot select this service! The following details are missing: ${missingFields.join(', ')}. Please update the Service Master first.`);
            this.products[index].selectedServiceId = '';
            this.products[index].service_name = '';
            return;
        }
        const product=this.products[index];
        product.hsn_no=res.hsn_no;
        product.ledger_name=res.ledger_name;
        product.ledger_id=res.ledger_id;
        product.uom=res.unit_name;
        product.unit_id=res.unit_id;
        product.specification=res.description;
        if (res.price != null && res.price !== '') {
         product.price = res.price;
       }
        product.service_name=res.service_name;
        product.sku_id =res.service_id;
        // product.selectedServiceId = res.service_id;
        product.category_name=res.category_name;
        product.category_id=res.category_id;
        product.branch_name=res.branch_name;
        product.branch_id=res.branch_id;
        product.profit_cost_name=res.profit_cost_name;
        product.profit_cost_id=res.profit_cost_id;
         this.products = [...this.products];
    },
    (error) => {
      console.error(error);
        alert(error?.error?.message );
    });

}
}